<div class="flex flex-middle flex-justify-center">
    <span class="p1 m-r-2">{{'Quantity' | translate}}:</span>
    <div class="flex flex-middle flex-justify-center p-a bg-col-w b-a b-col-5"
         style="border-radius: 20px; width: 116px;">
        <button class="col-1 flex flex-middle"
                [ngClass]="{'pe-none' : !canLess()}"
                type="button"
                (click)="less()"
                cy-decreaseQty>
            <i class="icon-minus flex"
               style="font-size: 16px;"
               aria-hidden="true"></i>
        </button>

        <div class="pos-relative">
            <input class="no-spinner p1 center m-r-3 m-l-3"
                   type="number"
                   [attr.step]="step()"
                   [disabled]="(!canMore() && !canLess())"
                   cy-qtyInput
                   #input
                   [(ngModel)]="model"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   (blur)="validate()"
                   [minWidth]="28"
                   autoSizeInput>
        </div>

        <button class="col-1 flex flex-middle"
                [ngClass]="{'pe-none' : !canMore()}"
                type="button"
                (click)="more()"
                cy-increaseQty>
            <i class="icon-plus flex"
               style="font-size: 16px;"
               aria-hidden="true"></i>
        </button>
    </div>
</div>